var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nrb"},[_c('app-NrbHero'),_c('app-AboutTraining'),_c('app-NrbProcess'),_c('u-testimonials',{attrs:{"items":_vm.items,"headline":"What Our Trainers Say"}}),_c('app-NrbPastSessions')],1)}
var staticRenderFns = []

export { render, staticRenderFns }